export const capitaliseWord = (word: string) =>
    word.charAt(0).toUpperCase() + word.slice(1);

export const daysAgo = (day: number) => {
    const date = new Date();
    date.setDate(date.getDate() - day);
    return date;
};
